import React, { useMemo } from "react";
import { observer } from "mobx-react";
import {
  FilterDivisor,
  FilterLabel,
  FiltersVisualization,
  Label,
  RuleSeparator,
} from "./RulesView.styled";
import { LogicalOp, RulesGroup } from "./RulesViewVisualization.styled";

const PostRulesView = observer(({ rules }) => {
  const hasRulesGroups = rules?.rulesGroups && Object.keys(rules.rulesGroups).length > 0;

  const groups = useMemo(() => {
    if (!hasRulesGroups) return [];
    return Object.values(rules.rulesGroups);
  }, [rules?.rulesGroups]);

  if (!hasRulesGroups) {
    return (
      <FiltersVisualization>
        <Label>
          No advanced filters available yet. <br /> Select a filter to get
          started.
        </Label>
      </FiltersVisualization>
    );
  }

  return (
    <FiltersVisualization>
      {groups.map((group, groupIndex) => {
        const validConditions = group?.conditions?.filter(
          (condition) =>
            condition.sourceData?.length &&
            condition.sourceField?.length &&
            condition.operator?.length &&
            condition.targetValue?.length
        );

        if (!validConditions.length) return null;

        return (
          <div key={groupIndex}>
            <FilterDivisor>
              <FilterLabel>Group {groupIndex + 1}</FilterLabel>

              {validConditions.map((condition, index) => (
                <RulesGroup key={index}>
                  {index >= 1 && <LogicalOp>AND</LogicalOp>}
                  <RulesGroup>
                    In <b>{condition.sourceData}</b>, if{" "}
                    <b>{condition.sourceField}</b> is{" "}
                    <b>{condition.operator}</b> to{" "}
                    <b>
                      {Array.isArray(condition.targetValue)
                        ? condition.targetValue.join(", ")
                        : condition.targetValue}
                    </b>
                  </RulesGroup>
                </RulesGroup>
              ))}
            </FilterDivisor>
            {groupIndex < groups.length - 1 && (
              <RuleSeparator>
                <span></span>
                <div> OR </div>
                <span></span>
              </RuleSeparator>
            )}
          </div>
        );
      })}
    </FiltersVisualization>
  );
});

export default PostRulesView;
